import { render, staticRenderFns } from "./recommendYuboya.vue?vue&type=template&id=ac3eeeb4&scoped=true&"
import script from "./recommendYuboya.vue?vue&type=script&lang=ts&"
export * from "./recommendYuboya.vue?vue&type=script&lang=ts&"
import style0 from "./recommendYuboya.vue?vue&type=style&index=0&id=ac3eeeb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3eeeb4",
  null
  
)

export default component.exports